import { useQuery } from '@tanstack/react-query';
import api from '~/api';
import { useStoreId } from '~/providers/StoreUserProvider';

const useQueryKey = () => {
  const storeId = useStoreId();
  return ['fulfillmentLocations', storeId] as const;
};

export default function useFulfillmentLocations() {
  const queryKey = useQueryKey();

  return useQuery({
    queryKey,
    queryFn: ({ queryKey: [, storeId] }) =>
      api.store(storeId).fulfillmentLocations.get(),
  });
}
